export function safeExecute(fn, errorMessage) {
  try {
    return fn();
  } catch (error) {
    console.error(errorMessage, error);
    return null;
  }
}
